"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var METADATA_POLL_PERIOD = 333;
var MetadataHandler = (function () {
    function MetadataHandler(stateObservable, sendCommand) {
        var _this = this;
        this.stateObservable = stateObservable;
        this.sendCommand = sendCommand;
        this.stateObservable.registerObserver(function (state) {
            switch (state) {
                case client_lib_js_player_addons_common_player_1.PlayerState.Playing:
                    _this.startRequestingMetadata();
                    return;
                case client_lib_js_player_addons_common_player_1.PlayerState.Paused:
                case client_lib_js_player_addons_common_player_1.PlayerState.Stopped:
                case client_lib_js_player_addons_common_player_1.PlayerState.Finished:
                    _this.stopRequestingMetadata();
                    return;
                default:
                    return;
            }
        }, this);
    }
    MetadataHandler.prototype.startRequestingMetadata = function () {
        var _this = this;
        this.stopRequestingMetadata();
        this.requestMetadata();
        this.metadataInterval = window.setInterval(function () { return _this.requestMetadata(); }, METADATA_POLL_PERIOD);
    };
    MetadataHandler.prototype.stopRequestingMetadata = function () {
        if (this.metadataInterval) {
            window.clearInterval(this.metadataInterval);
        }
        this.metadataInterval = null;
    };
    MetadataHandler.prototype.requestMetadata = function () {
        this.sendCommand('getPlaybackTime');
        this.sendCommand('getBitrate');
        this.sendCommand('getAudioTracks');
    };
    return MetadataHandler;
}());
exports.MetadataHandler = MetadataHandler;
